import RailsNestedForm from '@stimulus-components/rails-nested-form'

// Connects to data-controller="remove-participant"
export default class extends RailsNestedForm {
  remove (e: Event) {
    const target = e.target as HTMLElement
    const participantformFieldsContainer = target.closest('.nested-form-wrapper')

    participantformFieldsContainer?.remove()
  }
}
